import { ethers } from 'ethers';

import { AddressString, TVestaParameters } from '~components/providers/types';
import { IParameters } from '~services/types';
import { makeThrowable } from '~utils/error/errorHandlers';
import { ERROR_MSGS } from '~utils/error/errors';

export async function getVestaParameters(
  tokenAddress: AddressString,
  vpContract: TVestaParameters['read'],
): Promise<IParameters> {
  try {
    const [mcr, minNetDebt, vstMintCap, bonusToSp] = await Promise.all([
      vpContract.MCR([tokenAddress]),
      vpContract.MIN_NET_DEBT([tokenAddress]),
      vpContract.vstMintCap([tokenAddress]),
      vpContract.BonusToSP([tokenAddress]),
    ]);

    return {
      mcr: parseFloat(ethers.utils.formatEther(mcr)),
      minNetDebt: parseFloat(ethers.utils.formatEther(minNetDebt)),
      minNetDebtRaw: minNetDebt,
      vstMintCap: parseFloat(ethers.utils.formatEther(vstMintCap)),
      vstMintCapRaw: vstMintCap,
      bonusToSp: parseFloat(ethers.utils.formatEther(bonusToSp)),
    };
  } catch (err) {
    throw makeThrowable(ERROR_MSGS.CT_FETCH_SYS_PARAMS_FAIL);
  }
}
